import { render, staticRenderFns } from "./PrinorTabs-Content.vue?vue&type=template&id=4b332813&scoped=true&"
import script from "./PrinorTabs-Content.vue?vue&type=script&lang=js&"
export * from "./PrinorTabs-Content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b332813",
  null
  
)

export default component.exports